import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

export const currencyVariants = cva("font-light tabular-nums", {
  variants: {
    status: {
      default: "text-primary-900 dark:text-white",
      success:
        "rounded-none bg-green-50 px-2 py-1 text-green-800 dark:bg-green-950/40 dark:text-green-200",
      overdue:
        "rounded-none bg-red-50 px-2 py-1 text-red-800 dark:bg-red-950/40 dark:text-red-200",
    },
  },
  defaultVariants: {
    status: "default",
  },
});

export type CurrencyStatus = NonNullable<
  VariantProps<typeof currencyVariants>["status"]
>;

interface CurrencyProps {
  value: number | string;
  currency?: string;
  decimalPlaces?: number;
  status?: CurrencyStatus;
  className?: string;
}

export default function Currency({
  value,
  currency = "BRL",
  decimalPlaces = 2,
  status = "default",
  className,
}: CurrencyProps) {
  const numericValue = typeof value === "string" ? parseFloat(value) : value;

  const formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency,
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });

  return (
    <span className={cn(currencyVariants({ status }), className)}>
      {formatter.format(numericValue)}
    </span>
  );
}
